import React from "react";
import { NewModal, MainContentPaddingTypes, useAicoConnection } from "../..";
import NewButton from "../../BaseComponents/newButton";
import { useMutation } from "@apollo/client";
import { colors, fonts } from "../../../Styles";
import { LoadingSpinner } from "../../../Services/wrapper";
import { CLEAR_ALL_TABLES, ClearAllTablesArgs, ClearAllTablesResponse } from "../../../Services/Agrisys_GqlDataCaller/ServiceToolCalls/GQLCalls/clearAllTables";

interface ClearAllTablesProps {
	isModalOpen: boolean;
	closeModal: () => void;
}

export default function ClearAllTablesModal({
	isModalOpen,
	closeModal,
}: ClearAllTablesProps) {
	const { state: connectionState } = useAicoConnection();

	const [fetchData, { data, loading, error, reset }] = useMutation<ClearAllTablesResponse, ClearAllTablesArgs>(CLEAR_ALL_TABLES, {
		fetchPolicy: "network-only"
	});

	async function handleCommit() {
		if (!connectionState.deviceConnection) {
			return;
		}

		fetchData({ variables: connectionState.deviceConnection });
	}

	function handleCloseModal() {
		reset();
		closeModal();
	}

	return (
		<NewModal
			modalState={isModalOpen}
			header={"Clear All Tables"}
			predefinedButtons={{
				onClose: handleCloseModal,
			}}
			overrides={{
				mainContentPadding: MainContentPaddingTypes.secondary,
			}}
			mainContent={
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						gap: "60px",
						marginTop: "25px",
					}}
				>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							gap: "10px",
						}}
					>
						<p style={{ ...fonts.fontSize1, ...fonts.header, color: colors.whitePrimary }}>WARNING!</p>
						<p style={{ ...fonts.fontSize3, ...fonts.header, color: colors.whitePrimary, textAlign: "center" }}>
							This action will clear all the tables on the LAN Controller, <br />
							it will not contain any data, this action is irreversible!
						</p>
						{loading && <LoadingSpinner />}
						{(error
							|| (data?.controller && !data.controller.clearAllTables?.success)
						)
							&& <p style={{ ...fonts.fontSize2, ...fonts.paragraph, color: colors.systemRed, maxWidth: "500px" }}>ERROR: Failed to clear all tables</p>
						}
						{!loading
							&& !error
							&& data?.controller.clearAllTables?.success
							&& <p style={{ ...fonts.fontSize2, ...fonts.paragraph, color: colors.systemGreen, maxWidth: "500px" }}>Succesfully cleared all tables</p>
						}
					</div>
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							alignItems: "center",
							gap: "5px",
						}}
					>
						<NewButton
							content={"Clear All Tables"}
							onClick={handleCommit}
							disabled={loading}
						/>
						<NewButton
							content={"Cancel"}
							onClick={handleCloseModal}
							disabled={loading}
						/>
					</div>
				</div>
			}
		/>
	);
}
